import * as React from 'react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { formatWithTimeZoneName } from 'owa-timezone';
import { FullOptionsLink } from 'owa-options-link';
import { getUserTimeZone, getUserWorkingHoursTzId } from 'owa-session-store';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { observer } from 'mobx-react';
import { getTimeZoneDisplayName } from 'owa-timezone';
import getRegionalOptions from '../data/store/store';
import selectTimeZoneOption from '../data/mutators/selectTimeZoneOption';
import strings from 'owa-strings/owa-options-strings';

const styles = require('./Regional.scss');
const dropdownStyles = { label: styles.dropdown };

export type OnSave = (this: void, newTimeZone: string) => void;
type TimeZoneOption = IDropdownOption & { onSave?: OnSave };

export default observer(({ onSave, isQuick }: { onSave?: OnSave; isQuick?: boolean }) => {
    const { selectedTimeZone, supportedTimeZones } = getRegionalOptions();
    const timeZoneId = selectedTimeZone || getUserTimeZone();
    const whtzId = getUserWorkingHoursTzId();
    const tzWarning = timeZoneId != whtzId;

    const label = isQuick ? undefined : strings.option_regional_timeZone;
    const options: TimeZoneOption[] = supportedTimeZones.map(timeZone => ({
        key: timeZone.Value,
        text: getTimeZoneDisplayName(timeZone.Value),
        onSave: onSave,
    }));

    const whTz =
        tzWarning && formatWithTimeZoneName(strings.options_workingHours_timeZoneLabel, whtzId);

    const warningLabel =
        tzWarning && formatWithTimeZoneName(strings.option_regional_workingHoursInfo, timeZoneId);

    return (
        <div>
            <Dropdown
                label={label}
                options={options}
                selectedKey={timeZoneId}
                onChanged={onSelectDateFormat}
                styles={dropdownStyles}
            />
            {tzWarning && (
                <div>
                    <Label>{whTz}</Label>
                    <Label>{warningLabel}</Label>
                    <FullOptionsLink category="calendar" subcategory="view">
                        {strings.option_update_workingHoursLink}
                    </FullOptionsLink>
                </div>
            )}
        </div>
    );
});

function onSelectDateFormat({ key, onSave }: TimeZoneOption) {
    if (onSave) {
        onSave(key as string);
    } else {
        selectTimeZoneOption(key as string);
    }
}
